export class TimeOnly {
	public readonly hour: number;
	public readonly minute: number;
	public readonly second: number;
	public readonly millisecond: number;

	constructor(
		hour: number,
		minute: number,
		second: number,
		millisecond: number
	) {
		this.hour = hour;
		this.minute = minute;
		this.second = second;
		this.millisecond = millisecond;
	}

	public isEqualTo(other: TimeOnly): boolean {
		return this.hour === other.hour
			&& this.minute === other.minute
			&& this.second === other.second
			&& this.millisecond === other.millisecond;
	}

	public toISOString(): string {
		const formattedHour: string = this.formatWithPrecedingZeros(this.hour, 2);
		const formattedMinute: string = this.formatWithPrecedingZeros(this.minute, 2);
		const formattedSecond: string = this.formatWithPrecedingZeros(this.second, 2);
		const formattedMillisecond: string = this.formatWithPrecedingZeros(this.millisecond, 3);

		return `${formattedHour}:${formattedMinute}:${formattedSecond}.${formattedMillisecond}`;
	}

	public toString(): string {
		return this.toISOString();
	}

	public isInvalid(): boolean {
		return isNaN(this.hour)
			&& isNaN(this.minute)
			&& isNaN(this.second)
			&& isNaN(this.millisecond);
	}

	public static readonly InvalidValue: TimeOnly = new TimeOnly(NaN, NaN, NaN, NaN);

	private formatWithPrecedingZeros(value: number, minLength: number): string {
		const strValue: string = value.toString(10);

		return strValue.padStart(minLength, "0");
	}
}
